const getMcleodType = (type) => {
  const mcleodTypes = {
    bulkhead: "eq_op_bulkhead",
    containerOnFlat: "eq_op_container_flat",
    doubleDrop: "eq_op_double_drop",
    downloadable: "eq_op_downloadable_tru",
    foodGrade: "eq_op_food_grade",
    heated: "eq_op_heated",
    highCube: "eq_op_high_cube",
    liftGate: "eq_op_lift_gate",
    reeferStraightTruck: "eq_op_refrig_straight",
    rgn: "eq_op_rgn",
    rollUp: "eq_op_roll_up",
    standardHeight: "eq_op_standard_height",
    stepDeck: "eq_op_step_deck",
    swingDoors: "eq_op_swing_doors",
    trailerOnFlat: "eq_op_trailer_flat",
    ventedTrailer: "eq_op_vent_trailer",
    woodFloor: "eq_op_wood_floor",
    plated: "plated_trailers_yes",
    drayage: "drayage",
    dropTrailer: "drop_trailer_yes",
    eveningPickup: "evening_pu_del",
    hazmat: "hazmat_yes",
    intermodal: "intermodal",
    ltl: "ltl",
    powerOnly: "power_only_yes",
    privateFleet: "private_fleet",
    teams: "teams_yes",
    warehouse: "warehouse",
    agriculturalSupplies: "cargo_agri_farm",
    beer: "cargo_beer",
    beverages: "cargo_beverages",
    buildingMaterials: "cargo_building_mat",
    chemicals: "cargo_chemicals",
    coal: "cargo_coal_coke",
    commoditiesDryBulk: "cargo_commod_dry",
    construction: "cargo_construction",
    driveTow: "cargo_drive_tow",
    electronics: "cargo_electronics",
    floorLoaded: "cargo_floor_loaded",
    garbage: "cargo_garbage",
    grainFeed: "cargo_grain_feed",
    generalFreight: "cargo_gen_freight",
    householdGoods: "cargo_household",
    iceCream: "cargo_ice_cream",
    intermodalCargo: "cargo_intermodal",
    liquidOrGas: "cargo_liquids_gas",
    liquor: "cargo_liquor",
    livestock: "cargo_livestock",
    lumber: "cargo_logs_lumber",
    machinery: "cargo_machinery",
    meat: "cargo_meat",
    metal: "cargo_metal",
    mobileHomes: "cargo_mobile_homes",
    oilFieldEquipment: "cargo_oil_equip",
    other: "cargo_other",
    paperProducts: "cargo_paper_prod",
    paperRolls: "cargo_paper_rolls",
    passengers: "cargo_passengers",
    pork: "cargo_pork",
    produce: "cargo_produce",
    reeferFood: "cargo_reefer_food",
    seafood: "cargo_seafood",
    tobacco: "cargo_tobacco",
    usMail: "cargo_us_mail",
    utilities: "cargo_utilities",
    vehicles: "cargo_vehicles",
    water: "cargo_water_well"
  };

  return mcleodTypes[type];
};

export { getMcleodType };